const demo_app = {
    title: "You've successfully signed in the live preview!",
    subtitle: 'Here is your log in information:',
    username: 'Username: ',
    user_id: 'User ID: ',
    sign_out: 'Sign Out the Live Preview',
    continue_explore: 'Or continue to explore',
    customize_sign_in_experience: 'Customize Sign-in Experience',
    enable_passwordless: 'Enable Passwordless',
    add_social_connector: 'Add Social Connector',
};
export default demo_app;
